export default {
  INLINE: 'inline',
  BACKGROUND: 'background',
  OG_TAG: 'og_tag',
};
